export function extractYouTubeVideoId(url: string) {
  const regex =
    /(?:youtube\.com\/(?:[^\\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\\/\s]{11})/;
  const match = url.match(regex);
  return match ? match[1] : null;
}
